<template lang="html">
  <div class="blog-capsule-container">
    <b-card>
      <b-row>
        <b-col class="capsule-content-wrapper">
          <router-link
            tag="div"
            class="open-capsule"
            :to="{
              name: 'ShowCapsule',
              params: { capsuleId: capsule.id }
            }"
            v-if="capsule"
          >
            <span class="text">Open</span><i class="pe-7s-expand1 icon"></i>
          </router-link>
          <CapsuleContent :capsule="capsule" v-if="capsule" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import CapsuleContent from "@/components/capsule/CapsuleContent";

export default {
  components: {
    CapsuleContent
  },

  props: {
    capsule: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.blog-capsule-container /deep/ {
  .card {
    margin-bottom: 30px;
    border: 1px solid #efefef;
    border-top: 1px solid $primary-accent;
    background: $grey8;
    border-radius: 0.4em;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);

    .capsule-content-wrapper {
      padding-right: 30px;
      padding-left: 30px;
    }

    .open-capsule {
      text-align: right;
      padding-bottom: 20px;
      cursor: pointer;

      &:hover {
        .text {
          color: darken($grey3, 15%);
        }

        .icon {
          color: darken($primary-accent, 15%);
        }
      }

      .text {
        margin-top: -3px;
        margin-right: 10px;
        letter-spacing: 1.4px;
        font-size: 12px;
        font-weight: 400;
        text-transform: uppercase;
        color: $grey3;
      }

      .icon {
        color: $primary-accent;
        vertical-align: middle;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blogEntry/BlogCapsule.vue